import { render } from "./BitcoinDetailBlocks.vue?vue&type=template&id=1d3cb5c9&scoped=true"
import script from "./BitcoinDetailBlocks.vue?vue&type=script&lang=js"
export * from "./BitcoinDetailBlocks.vue?vue&type=script&lang=js"

import "./BitcoinDetailBlocks.vue?vue&type=style&index=0&id=1d3cb5c9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3cb5c9"]])

export default __exports__